import React from 'react';

function Investments() {
  const investmentItems = [
    {
      title: "Real Estate",
      description: "We focus on secure, high-potential properties, whether it's a rental apartment, commercial building, or prime land. Real estate offers tangible assets and stable long-term growth.",
      image:"/WhatsApp Image 2025-05-07 at 14.52.29_ead1e71a.jpg"
    },
    {
      title: "Bitcoin",
      description: "Recognizing the impact of digital currencies, we allocate a portion of funds to Bitcoin, adhering to a measured approach and thorough market analysis.",
      image: "/WhatsApp Image 2025-05-07 at 14.52.45_7dc62b27.jpg"
    },
    {
      title: "IPOs",
      description: "Through strategic partnerships, we gain access to UAE IPOs, capturing value at the ground floor of promising companies.",
      image: "/WhatsApp Image 2025-05-07 at 14.52.56_fa0dee70.jpg"
    },
    {
      title: "Luxury Taxis",
      description: "We invest in luxury taxi fleets in high-demand cities like Dubai, tapping into daily operational revenues and potential brand growth.",
      image: "/WhatsApp Image 2025-05-07 at 14.52.14_d80638a9.jpg"
    },
    {
      title: "Startups",
      description: "A small percentage of our portfolio supports early-stage businesses with scalable ideas, helping founders bring innovative concepts to life, while aiming for long-term returns.",
      image: "/WhatsApp Image 2025-05-07 at 14.51.52_a536fa62.jpg"
    },
    {
      title: "Diversified Approach",
      description: "Our investment strategy is carefully balanced to maximize growth while managing risk across multiple asset classes.",
      image:" /Art Vote GIF by New York Moves Magazine.gif"
    }
  ];

  return (
    <section id="investments" style={{
      padding: '3rem 0',
      background: 'white',
      fontFamily: 'Poppins, sans-serif',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }}>
      <div style={{
        maxWidth: '80rem',
        margin: '0 auto',
        padding: '0 1rem',
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
      }}>
        <div>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: '700',
            color: '#1F1F1F',
            marginBottom: '3rem',
            textAlign: 'center',
            animation: 'fadeIn 1s ease-in-out',
          }}>
            What We Invest In
            <div style={{
              width: '6rem',
              height: '0.375rem',
              backgroundColor: '#D69E2E',
              margin: '1rem auto 0',
              borderRadius: '0.25rem',
            }}></div>
          </h2>

          <p style={{
            fontSize: 'clamp(1rem, 3vw, 1.1rem)',
            marginBottom: '2rem',
            textAlign: 'center',
            maxWidth: '60rem',
            marginLeft: 'auto',
            marginRight: 'auto',
            color: '#475569',
            lineHeight: '1.6',
            animation: 'fadeInUp 1s ease-out 0.3s',
            animationFillMode: 'backwards',
            padding: '0 1rem'
          }}>
            At AIC, we diversify across a handful of carefully selected asset classes, balancing potential returns with prudent risk management.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(min(300px, 100%), 1fr))',
          gap: '1.5rem',
          alignItems: 'stretch',
          padding: '0 0.5rem',
          margin: '2rem 0'
        }}>
          {investmentItems.map((item, index) => (
            <div key={index} style={{
              borderRadius: '0.8rem',
              overflow: 'hidden',
              backgroundColor: '#FFF7ED',
              border: '1px solid #DBEAFE',
              transition: 'transform 0.4s ease, box-shadow 0.4s ease',
              boxShadow: '0 4px 8px rgba(0,0,0,0.08)',
              animation: `cardPop 0.8s ease-out ${0.2 * index}s`,
              animationFillMode: 'backwards'
            }}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <div style={{
                height: 'clamp(180px, 30vw, 200px)',
                overflow: 'hidden',
                position: 'relative'
              }}>
                <img
                  src={process.env.PUBLIC_URL + item.image}
                  alt={item.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    transition: 'transform 0.6s ease, opacity 0.6s ease'
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.15)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                />
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  right: 0,
                  height: '50%',
                  background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                  transition: 'height 0.4s ease'
                }}></div>
              </div>
              <div style={{
                padding: '1.25rem'
              }}>
                <h3 style={{
                  fontSize: 'clamp(1.1rem, 4vw, 1.3rem)',
                  fontWeight: '600',
                  marginBottom: '0.5rem',
                  color: '#1E3A8A',
                  transition: 'color 0.3s ease'
                }}>
                  {item.title}
                </h3>
                <p style={{
                  fontSize: 'clamp(0.9rem, 3vw, 1rem)',
                  color: '#4B5563',
                  lineHeight: '1.5',
                  marginBottom: item.title === "Diversified Approach" ? '1rem' : 0
                }}>
                  {item.description}
                </p>

                {item.title === "Diversified Approach" && (
                  <a
                    href="https://t.me/AICUAE"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-block',
                      backgroundColor: '#1F1F1F',
                      color: '#FFFFFF',
                      padding: '0.75rem 1.75rem',
                      borderRadius: '0.75rem',
                      fontSize: '1rem',
                      fontWeight: '600',
                      textDecoration: 'none',
                      animation: 'pulse 2s infinite',
                      transition: 'all 0.3s ease',
                      boxShadow: '0 4px 6px rgba(255, 255, 255, 0.2)',
                    }}
                    onMouseEnter={e => {
                      e.currentTarget.style.backgroundColor = '#333333';
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 8px 15px rgba(0, 0, 0, 0.3)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.backgroundColor = '#1F1F1F';
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 4px 6px rgba(255, 255, 255, 0.2)';
                    }}
                  >
                    Learn More
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>

        
      </div>

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes cardPop {
          from {
            opacity: 0;
            transform: scale(0.85) translateY(20px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        div[style*="borderRadius: '0.8rem'"]:hover {
          box-shadow: 0 10px 20px rgba(0,0,0,0.15);
        }

        div[style*="borderRadius: '0.8rem'"]:hover h3 {
          color: #2563EB;
        }

        @media (max-width: 640px) {
          section#investments {
            padding: 2rem 0;
          }

          div[style*="maxWidth: '80rem'"] {
            padding: 0 0.5rem;
          }

          div[style*="gridTemplateColumns"] {
            gap: 1.25rem;
            padding: 0 0.5rem;
          }

          div[style*="height: 'clamp(180px, 30vw, 200px)'"] {
            height: 160px;
          }

          div[style*="padding: '1.25rem'"] {
            padding: 1rem;
          }

          button[style*="minWidth: '140px'"] {
            padding: 0.65rem 1.5rem;
            minWidth: 130px;
          }
        }

        @media (max-width: 400px) {
          section#investments {
            padding: 1.5rem 0;
          }

          h2[style*="fontSize: 'clamp(1.8rem, 5vw, 2.5rem)'"] {
            fontSize: 1.6rem;
          }

          p[style*="fontSize: 'clamp(1rem, 3vw, 1.1rem)'"] {
            fontSize: 0.95rem;
          }

          div[style*="gridTemplateColumns"] {
            gridTemplateColumns: 1fr;
          }
        }
      `}</style>
    </section>
  );
}

export default Investments;
